<div class="modal-header p-1 mb-1">
  <h6 class="modal-title" id="modal-text-orange">Payment History</h6>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<!--<span class="text-blue requiredb4 p-2">&nbsp;Marked fields are Required<br></span>-->
<div class="modal-body p-2 mb-2">
  <!--<form>{{routeDetail}}</form>-->  
  <div class="table-responsive"  id="print-section">                  
    <!--<table class="table table-hover table-fit">-->
    <table class="table table-hover">
      <thead class="thead-dark">
        <tr> 
          <th>Fee Type</th> 
          <th>Amount</th> 
          <th>Paid On</th> 
          <th>Mode</th>
          <th>Payment Ref</th>
          <th>Order Ref</th>
          <th>Status</th>
          <th>Comment</th>
          <th>Receipt</th>
          <!--<th>Action</th>-->  
        </tr>
      </thead>
      <tbody>
        <tr style="cursor:pointer;" *ngFor="let paymentHist of paymentHistory">
          <td >{{paymentHist.feeType}}</td>
          <td >{{paymentHist.paidAmount}}</td>
          <td >{{paymentHist.paidDate | date: dateTimeFormat}}</td>
          <td >{{paymentHist.paymentMode}}</td>
          <td >{{paymentHist.paymentRef}}</td>
          <td >{{paymentHist.orderRef}}</td>
          <td >{{paymentHist.status}}</td>
          <td >{{paymentHist.comment}}</td>
          <td *ngIf="paymentHist.receiptNumber">
            <a class="btn p-0 text-lightning">
              {{paymentHist.receiptNumber}}&nbsp;<i class="fa fa-download" style="color: red" (click)="downloadReceipt(paymentHist.id)"></i>&nbsp;                                      
            </a>
          </td>
          <td *ngIf="!paymentHist.receiptNumber">
            <button  class="btn-custom p-1" (click)="generateReceipt(paymentHist.id)">Generate Receipt</button>&nbsp;
          </td>
          <!--<td>   
            <a class="btn p-0 text-lightning">
              <i class="far fa-trash-alt" style="color: red"></i>&nbsp;                                      
            </a>&nbsp;&nbsp;
          </td>--> 
        </tr>
      </tbody>
    </table>
  </div>
</div><!-- modal body-->

<div class="modal-footer">
  <button type="button" class="btn-custom p-1" (click)="close()">Cancel</button>
</div>
